// src/components/image-dashboard/CropModal.jsx
import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";

const CropModal = ({ file, onClose, onCropped }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    useEffect(() => {
        const reader = new FileReader();
        reader.onload = () => setImageSrc(reader.result);
        reader.readAsDataURL(file);

        const handleEsc = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [file, onClose]);

    const onCropComplete = useCallback((_, pixels) => setCroppedAreaPixels(pixels), []);

    const getCroppedImg = useCallback(async () => {
        if (!imageSrc || !croppedAreaPixels) return null;
        const createImage = url => new Promise((res, rej) => { const img = new Image(); img.onload = () => res(img); img.onerror = rej; img.src = url; });
        const image = await createImage(imageSrc);
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(croppedAreaPixels.width);
        canvas.height = Math.round(croppedAreaPixels.height);
        const ctx = canvas.getContext("2d");
        ctx.drawImage(
            image,
            Math.round(croppedAreaPixels.x),
            Math.round(croppedAreaPixels.y),
            Math.round(croppedAreaPixels.width),
            Math.round(croppedAreaPixels.height),
            0,
            0,
            canvas.width,
            canvas.height
        );
        return new Promise(resolve => canvas.toBlob(blob => resolve(blob), "image/jpeg", 0.92));
    }, [imageSrc, croppedAreaPixels]);

    const handleConfirm = async () => {
        const blob = await getCroppedImg();
        if (blob) onCropped(blob, `cropped_${file.name}`);
    };

    return (
        <div className="cropOverlay" onClick={onClose}>
            <div className="cropBox" onClick={e => e.stopPropagation()}>
                <h3 className="modalTitle">Crop Image</h3>
                <div className="cropArea">
                    {imageSrc && (
                        <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={16 / 9}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />
                    )}
                </div>
                <div className="actions">
                    <button className="confirm" onClick={handleConfirm}>Apply Crop</button>
                    <button className="cancel" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default CropModal;
